module.exports = __webpack_public_path__ + "img/board_thum2.15463a35.png";